/**
 * This file contains the definition of tour steps for the product tour in the CBO platform.
 * It exports an array of `Step` objects that represent each step in the tour.
 */

import { Step } from 'react-joyride';
import { isGlobalEnv } from '../../libs/helper/HelperFunctions';
export const adminTourStepsOnly = ['Messages'];
export const tourSteps: Step[] = [
  {
    title: `Profile`,
    target: '.tour-profile',
    content:
      'Profile contains a brief description of your name and roles in the Engineering & Analytics platform',
    disableBeacon: true,
  },
  {
    title: `Add Pursuit`,
    target: '.tour-add-pursuit',
    content:
      'Personalize your pursuit with a pre-defined journey and corresponding capabilities under Advise, Implement and Operate philosophy',
    disableBeacon: true,
  },
  {
    title: `Search`,
    target: '.tour-search',
    content: 'Search your pursuits from the pursuit listing dashboard',
    disableBeacon: true,
  },
  {
    title: `Filter`,
    target: '.tour-filter',
    content: 'Filter your pursuits based on the status and tags of the pursuit',
  },
  {
    title: `Pursuit Dashboard`,
    target: '.tour-cboDashboard',
    content: 'View all your pursuits based on your configuration.',
    disableBeacon: true,
  },
  {
    title: `Engagement Dashboard`,
    target: '.tour-cboEngagementDashboard',
    content: 'View all your engagements based on your configuration.',
    disableBeacon: true,
  },
  {
    title: `Artefact Repo`,
    target: '.tour-marketplace',
    content:
      'Refer to all the supporting documents, quals, presentation and toolkits for your selected pre-defined journey.',
    disableBeacon: true,
  },
  {
    title: `Actions`,
    target: '.tour-actions',
    content: 'Edit and delete your pursuit and Configure Assets for your pursuit',
    disableBeacon: true,
  },
  {
    title: `View/Update Status`,
    target: '.tour-status',
    content: 'View/Update the status of your pursuit and engagement',
    disableBeacon: true,
  },
  {
    title: `View Summary`,
    target: '.tour-summary',
    content: 'View your summary dashboard for your journey.',
    disableBeacon: true,
  },
  {
    title: `Marketplace Search`,
    target: '.tour-cboMarketplaceSearch',
    content: isGlobalEnv()
      ? 'Access to comprehensive collection of Go To Market materials.'
      : 'Access to comprehensive collection of Smart Starts and Go To Market materials.',
    disableBeacon: true,
  },
  {
    title: `Configuration`,
    target: '.tour-settings',
    content:
      'Manage the Client, Pursuit, User Configurations, Master Data, User Client Mappings, SmartStart and Journey Builder',
    disableBeacon: true,
  },
  {
    title: `Reports`,
    target: '.tour-cboReports',
    content:
      'View all your reports based on your configuration. You can also download the reports in CSV format.',
    disableBeacon: true,
  },
  {
    title: `Support`,
    target: '.tour-feedback',
    content: 'Queries or Feedback? Please access the support.',
    disableBeacon: true,
  },
];
